import React from 'react'
import { Main } from 'todistukset-ui/src/vtj/components/page-content/PageContent.sc'
import TabNavigation from 'todistukset-ui/src/vtj/components/tab-navigation/tab-navigation.react'
import { PageConfig } from 'todistukset-ui/src/vtj/components/page-router/TodistuksetRouter.types'
import PageRoutes from 'todistukset-ui/src/vtj/todistukset-page-routes.enum'
import StepRoutes from 'todistukset-ui/src/vtj/todistukset-step-routes.enum'
import { observer } from 'mobx-react'
import AetTodistuspyyntoBanner from 'todistukset-ui/src/vtj/components/aet-todistuspyynto-banner/AetTodistuspyyntoBanner.react'

export interface PageContentProps {
  visiblePage: PageConfig
  page: PageRoutes
  step?: StepRoutes
  shouldUseLandingPageStyles?: boolean
}

function PageContent(props: PageContentProps): React.JSX.Element {
  const { visiblePage, step, page, shouldUseLandingPageStyles } = props

  if (visiblePage.isStep) {
    return (
      <MainComponent {...{ shouldUseLandingPageStyles, step }}>
        <visiblePage.component
          step={step}
          page={page}
          getSteps={visiblePage.getSteps}
        />
      </MainComponent>
    )
  }

  return (
    <MainComponent {...{ shouldUseLandingPageStyles, step }}>
      <visiblePage.component page={page} />
    </MainComponent>
  )
}

const MainComponent: React.FC<{
  children: React.JSX.Element
  shouldUseLandingPageStyles?: boolean
  step?: StepRoutes
}> = ({ children, shouldUseLandingPageStyles, step }) => {
  return (
    <Main id="main-content">
      {shouldUseLandingPageStyles && (
        <>
          {!step && <AetTodistuspyyntoBanner />}
          <TabNavigation shouldUseLandingPageStyles />
        </>
      )}
      {children}
    </Main>
  )
}

export default observer(PageContent)
